import React, { useState, useEffect } from "react";
import { collection, getDocs, getDoc, doc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../assets/goBackarrow.svg";
import Verify from "../../assets/verified.svg";
  import { deleteDoc } from "firebase/firestore";

import './email.css'

const UserEmailsPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/");
        return;
      }
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists() && userDoc.data().role !== "admin") {
        navigate("/");
      }
    };
    checkAdmin();
  }, [navigate]);

  useEffect(() => {
const fetchUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const userList = querySnapshot.docs.map((doc) => ({
      id: doc.id, // Store the document ID
      name: doc.data().firstName || doc.data().displayName || "No Name",
      email: doc.data().email || "No Email",
    }));
    setUsers(userList);
  } catch (error) {
    setError("Error fetching user data.");
  } finally {
    setLoading(false);
  }
};
    fetchUsers();
  }, []);



const handleDeleteUser = async (userId, userName) => {
  const confirmDelete = window.confirm(`Are you sure you want to delete ${userName}? This cannot be undone.`);
  
  if (confirmDelete) {
    try {
      await deleteDoc(doc(db, "users", userId));
      // Remove from local state so the UI updates immediately
      setUsers(users.filter(user => user.id !== userId));
      alert("User deleted successfully from database.");
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user.");
    }
  }
};

const downloadCSV = () => {
  const headers = "Name,Email\n";
  
  const rows = users.map(u => {
    // Escaping double quotes and wrapping values in quotes
    const name = u.name.replace(/"/g, '""'); 
    const email = u.email.replace(/"/g, '""');
    return `"${name}","${email}"\n`;
  }).join(""); // Join array into a single string

  const blob = new Blob([headers + rows], { type: "text/csv;charset=utf-8;" });

    const url = window.URL.createObjectURL(blob);
    
    // 4. Create a temporary link and trigger click
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "user_list.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (loading) return <Loader />;

  return (
    <div className="admin-review">
      <div style={{ paddingTop: 16 }} className="onboardingBackBTN">
        <button onClick={() => navigate(-1)}>
          <img src={BackArrow} alt="back button" />
        </button>
        <p style={{ fontSize: 18, fontWeight: "600", color: "#e91e63", display: "flex", gap: 6 }}>
          Users Directory <img style={{ width: 15 }} src={Verify} alt="" />
        </p>
        <button onClick={downloadCSV} className="download-btn">
           CSV
        </button>
      </div>

      <div className="email-list-container">
        <table className="user-table">
  <thead>
    <tr>
      <th>Name</th>
      <th>Email</th>
      <th>Action</th> {/* New Header */}
    </tr>
  </thead>
  <tbody>
    {users.map((user) => (
      <tr key={user.id}>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td>
          <button 
            onClick={() => handleDeleteUser(user.id, user.name)}
            style={{
              backgroundColor: "#ff4d4d",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Delete
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
      </div>
    </div>
  );
};

export default UserEmailsPage;